import { render, staticRenderFns } from "./TutoCard.vue?vue&type=template&id=978cd190&scoped=true&"
import script from "./TutoCard.vue?vue&type=script&lang=js&"
export * from "./TutoCard.vue?vue&type=script&lang=js&"
import style0 from "./TutoCard.vue?vue&type=style&index=0&id=978cd190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978cd190",
  null
  
)

export default component.exports